import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-top" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "header-action-icon" }
const _hoisted_8 = ["fill"]
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "subtitle" }

import { computed, ref } from 'vue';
import { default as ColourPicker } from '@/shared/services/color';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeScreenHeader',
  props: {
  brandColour: {
    type: String,
    required: true,
  },
  homescreenImageUrl: {
    type: String,
    default: true,
  },
  greetingText: {
    type: String,
    default: '',
  },
  introductionText: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

const isChatBoxOpen = ref(true);
const isFullscreen = ref(false);
const textColour = computed(() => ColourPicker.getContrastingColour(props.brandColour));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.homescreenImageUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", { src: __props.homescreenImageUrl }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([[isChatBoxOpen.value ? 'fadeIn' : 'fadeOut'], "close-icon"]),
            fill: textColour.value,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }, null, -1),
            _createElementVNode("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            }, null, -1)
          ]))], 10, _hoisted_8))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tooltip" }, [
          _createElementVNode("span", { class: "tooltiptext" }, "Close")
        ], -1))
      ], 512), [
        [_vShow, isChatBoxOpen.value && isFullscreen.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, _toDisplayString(__props.greetingText), 1),
    _createElementVNode("div", _hoisted_10, _toDisplayString(__props.introductionText), 1)
  ]))
}
}

})